import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';

const WidgetSectionTitle = ({title = ''}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        maxWidth: 800,
      }}
    >
      <Typography
        variant='h4'
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px',
          color: 'text.secondary',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

WidgetSectionTitle.propTypes = {
  title: PropTypes.string,
};

export default WidgetSectionTitle;
